<script>
	let { schedule } = $props();

	const now = new Date();
	const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
	const visibleDays = $derived(schedule.days.filter((d) => d.date >= today));

	function formatDate(dateStr) {
		const date = new Date(dateStr + 'T00:00:00');
		return date.toLocaleDateString('en-US', {
			weekday: 'long',
			month: 'long',
			day: 'numeric',
		});
	}
</script>

<section class="bg-parchment-dark py-10 md:py-12">
	<div class="section-container">
		<div class="mx-auto max-w-4xl">
			<h2 class="text-center font-heading text-2xl font-bold text-navy md:text-3xl">
				{schedule.title}
			</h2>
			<div class="mt-6 space-y-4">
				{#each visibleDays as day (day.date)}
					<div
						class="rounded-lg border p-5 {day.date === today
							? 'border-gold border-2 bg-stone'
							: 'border-stone-dark bg-stone'}"
					>
						<div class="flex flex-wrap items-baseline gap-2">
							<h3 class="font-heading text-lg font-semibold text-navy">
								{formatDate(day.date)}
							</h3>
							{#if day.date === today}
								<span class="rounded-full bg-gold px-2 py-0.5 text-xs font-semibold text-white"
									>Today</span
								>
							{/if}
						</div>
						<p class="font-heading text-base font-medium text-wine">{day.name}</p>
						{#if day.subtitle}
							<p class="mt-1 text-sm italic text-navy-muted">{day.subtitle}</p>
						{/if}
						<div class="mt-3 space-y-1.5">
							{#each day.services as service}
								<div class="flex justify-between gap-4">
									<span class="text-sm text-navy-light">{service.name}</span>
									<span class="whitespace-nowrap text-sm font-semibold text-navy"
										>{service.time}</span
									>
								</div>
							{/each}
						</div>
					</div>
				{/each}
			</div>
		</div>
	</div>
</section>
